'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _centralizedauth = require('./centralizedauth');

Object.defineProperty(exports, 'centralizedAuth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_centralizedauth).default;
  }
});

var _usermetadata = require('./usermetadata');

Object.defineProperty(exports, 'UserMetadata', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_usermetadata).default;
  }
});

var _delegation = require('./delegation');

Object.defineProperty(exports, 'Delegation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_delegation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/simple-auth-wrapper/lib/index.js
// module id = 349
// module chunks = 0